import { CONTACT_SALES, Pricing } from '../pricing/pricing';

export class Sellable {
  pricing: Pricing;

  get isFree(): boolean {
    return this.pricing && this.pricing.prices
      ? this.pricing.prices.some((p) => p.price === 0 || p.price === undefined)
      : false;
  }

  get shouldContactSales(): boolean {
    return this.pricing && this.pricing.prices
      ? this.pricing.prices.some((p) => p.price === null || p.price === CONTACT_SALES) ||
          this.pricing.prices.length === 0
      : true;
  }

  static getCapitalizeFirstLetter(inputString: string): string {
    return inputString ? inputString.charAt(0).toUpperCase() + inputString.slice(1) : null;
  }

  get formattedPricingList(): string[] {
    if (this.pricing && this.pricing.prices && this.pricing.prices.length) {
      const hasCurrencyAndIsNotUSD = this.pricing.currency && this.pricing.currency !== 'USD';
      const currencyStr = hasCurrencyAndIsNotUSD ? this.pricing.currency : '';
      const currencySymbol = Sellable.getCurrencySymbol(this.pricing.currency);

      return this.pricing.prices.map((price) => {
        const frequencyStr = price.frequency ? '/ ' + Sellable.getCapitalizeFirstLetter(price.frequency) : '';
        const roundedPrice = ((price.price || 0) / 100.0).toFixed(2);
        const startingAtPrefix = price.isStartingPrice ? 'Starting at ' : '';
        const priceStr = `${startingAtPrefix}${currencySymbol}${roundedPrice} ${currencyStr} ${frequencyStr}`;
        return priceStr.trim().replace(/\s+/g, ' ');
      });
    } else {
      return ['Contact Sales'];
    }
  }

  get priceStrings(): string[] {
    if (this.shouldContactSales) {
      return ['Contact Sales'];
    }

    if (this.isFree) {
      return ['Free'];
    }

    return this.formattedPricingList;
  }

  get formattedWholesalePrice(): string {
    return this.priceStrings.join(' + ');
  }

  static getCurrencySymbol(currency: string): string {
    let currencySymbol = '$';
    switch (currency) {
      case 'EUR':
        currencySymbol = '\u20AC';
        break;
      case 'GBP':
        currencySymbol = '\u00A3';
        break;
      case 'CHF':
        currencySymbol = 'Fr';
        break;
      case 'CNY':
        currencySymbol = '\u00A5';
        break;
      case 'JPY':
        currencySymbol = '\u00A5';
        break;
      case 'CZK':
        currencySymbol = 'K\u010d';
        break;
      case 'INR':
        currencySymbol = '\u20B9';
        break;
      case 'KHR':
        currencySymbol = '\u17DB';
        break;
      case 'KRW':
        currencySymbol = '\u20A9';
        break;
      case 'NOK':
        currencySymbol = 'kr';
        break;
      case 'SEK':
        currencySymbol = 'kr';
        break;
      case 'RUB':
        currencySymbol = '\u20BD';
        break;
      case 'TRY':
        currencySymbol = '\u20BA';
        break;
      case 'ZAR':
        currencySymbol = 'R';
        break;
      default:
        currencySymbol = '$';
        break;
    }
    return currencySymbol;
  }
}
